import React from 'react';
import PropTypes from 'prop-types';
import { formats } from 'utils';

import { Card, Typography, Link } from '../../../alf-design';

const AgencyDetails = ({ policy: { agent } }) => {
  const agentAddress = formats.address(agent);
  const phone = formats.phoneFormat(agent.phone);
  return (
    <Card className="grid">
      <Typography type="h2" component="h2" className="mb-[24px]">
        Agency Details
      </Typography>
      <div className="grid gap-[8px]">
        <Typography id="organizationName" type="caption2">
          {agent.organizationName}
        </Typography>
        <Typography type="caption1">{agentAddress}</Typography>
        {phone && (
          <Link id="agentPhone" href={`tel:${phone}`}>
            {phone}
          </Link>
        )}
        {agent.email && (
          <Link
            id="agentEmail"
            type="primary"
            href={`mailto:${agent.email}`}
            email
          >
            {agent.email}
          </Link>
        )}
      </div>
    </Card>
  );
};
AgencyDetails.propTypes = {
  policy: PropTypes.object,
};

export default AgencyDetails;
